<template>
  <div>
    <a-tree-select
      :multiple="false"
      :placeholder="placeholder"
      :fieldNames="{ label: 'name',  value: 'id' }"
      :tree-data="orgTreeData"
      :value="value"
      :disabled="disabled"
      :treeDefaultExpandAll="true"
      class="w100"
      show-search
      @change="onChange"
      @select="onSelect"
    ></a-tree-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, toRefs} from "vue";
import { ProjectDocumentService } from "@/views/work-manage/project-document/project-document.service";
import { FolderTreeRecord} from "@/views/work-manage/project-document/project-document.interface";
import ArrayToTree from "array-to-tree";


export default defineComponent({
  isGlobal: true,
  name: "ProjectFolderTree",
  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },
    projectId: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:value", "select"],
  setup(props, { emit }) {

   const state = reactive<{
     orgTreeData: FolderTreeRecord[]
   }>({
      orgTreeData: [],
    });

    const { data, run, loading } = ProjectDocumentService.useFolderTreeApi();

    const onChange = (id) => {
      emit("update:value", id);
    };


    const onSelect = (id, { value, title }) => {
      emit("select", { id, name: title });
    };
    const search = async () => {
      const res = await run(props?.projectId);
      if (res.respCode === "0000") {
        let list = res.data?.records || [];
        state.orgTreeData = ArrayToTree((list), {
            parentProperty: "parentId",
            customID: "id",
        });
        // console.log('state.orgTreeData',state.orgTreeData)
        if (!props.value) {
          const treeList = JSON.parse(JSON.stringify(state.orgTreeData))
          emit("update:value", treeList[0]?.id);
        }
      }
    };

    onMounted(async () => {
      await search();
    });

    return {
      ...toRefs(state),
      data,
      loading,
      search,
      onChange,
      onSelect,
    };
  },
});
</script>
